<template>
  <div>
    <h2 class="page-titles">Add credit card</h2>

    <div class="arrow-link">
      <router-link :to="{ name: 'billing', query: { tab: 'payment' } }">
        <span> Back to payments</span>
      </router-link>
    </div>

    <form id="payment-form" @submit.prevent="stripeTokenHandler">
      <section class="form-holder">
        <!-- Card Number here -->
        <div class="form-group">
          <div id="card-number" class="form-control"></div>
        </div>

        <!-- Name on card here -->
        <div class="form-group">
          <input
            type="text"
            placeholder="Name on card *"
            class="form-control"
            v-model="cardHolderName"
          />
        </div>

        <!-- Card Details here -->
        <div class="form-group inline-inputs">
          <label>Expiration*</label>
          <div id="card-expiry"></div>
          <div id="card-cvc"></div>
        </div>

        <!-- Address 1 here -->
        <div class="form-group">
          <input
            type="text"
            placeholder="Address Line 1 *"
            class="form-control"
            v-model="addressOne"
          />
        </div>

        <!-- Address 2 here -->
        <div class="form-group">
          <input
            type="text"
            placeholder="Address Line 2"
            class="form-control"
            v-model="addressTwo"
          />
        </div>

        <!-- City  here -->
        <div class="form-group">
          <input
            type="text"
            placeholder="City *"
            class="form-control"
            v-model="city"
          />
        </div>

        <!-- State here -->
        <div class="form-group">
          <input
            type="text"
            placeholder="State *"
            class="form-control"
            v-model="state"
          />
        </div>

        <!-- Postal Code Here -->
        <div class="form-group">
          <input
            type="text"
            placeholder="Postal Code *"
            class="form-control"
            v-model="zipcode"
          />
        </div>
      </section>

      <!-- Error alert here -->
      <p id="card-errors" role="alert" class="card-errors"></p>

      <!-- Button here -->
      <div class="text-left flex justify-center" style="padding-top: 1rem">
        <button
          class="button-gemnote button-gemnote--small"
          :class="{ 'button-gemnote--disabled': submittingPaymentMethod }"
          :disabled="submittingPaymentMethod"
        >
          <span>Save</span>
        </button>
      </div>

      <div class="flex items-center justify-center margin-top-2 gap-1 item">
        <img src="../../assets/guard.svg" alt="check" class="w-4" />
        <span>SSL Secure Encryption</span>
      </div>
    </form>
  </div>
</template>

<script>
let [stripe, elements, cardNumber, cardExpiry, cardCvc] = []
import { mapState } from 'vuex'
import { paymentMethodType } from '../../helpers'
// import StripeProvider from '@/components/Stripe/StripeProvider'

export default {
  name: 'StripeElement',
  data: function() {
    return {
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      cardHolderName: '',
      addressOne: '',
      addressTwo: '',
      city: '',
      state: '',
      zipcode: ''
    }
  },
  created() {
    stripe = Stripe(this.publicKey) // eslint-disable-line no-undef
    elements = stripe.elements()

    cardNumber = elements.create('cardNumber', {
      style: {
        base: {
          color: '#25282a',
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif',
          padding: '13px 0px 13px 0px',

          '::placeholder': {
            fontSize: '13px',
            color: '#9B9B9B',
            textTransform: 'uppercase'
          }
        }
      },
      placeholder: 'Card number *'
    })

    cardExpiry = elements.create('cardExpiry', {
      style: {
        base: {
          color: '#25282a',
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif',
          padding: '13px 0px 13px 0px',
          '::placeholder': {
            fontSize: '13px',
            color: '#9B9B9B',
            textTransform: 'uppercase'
          }
        }
      },
      placeholder: 'MM/YYYY'
    })

    cardCvc = elements.create('cardCvc', {
      style: {
        base: {
          color: '#25282a',
          fontSize: '14px',
          fontFamily: 'Nunito Sans, sans-serif',
          padding: '13px 0px 13px 0px',
          '::placeholder': {
            fontSize: '13px',
            color: '#9B9B9B',
            textTransform: 'uppercase'
          }
        }
      },
      placeholder: 'CVV *'
    })
  },

  mounted() {
    cardNumber.mount('#card-number')
    cardNumber.focus()
    cardNumber.on('change', function(event) {
      let displayError = document.getElementById('card-errors')
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })

    cardExpiry.mount('#card-expiry')
    cardExpiry.on('change', function(event) {
      let displayError = document.getElementById('card-errors')
      if (event.error) {
        // for card number incomplete

        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })

    cardCvc.mount('#card-cvc')
    cardCvc.on('change', function(event) {
      let displayError = document.getElementById('card-errors')
      if (event.error) {
        // for card number Expiration
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })
  },
  methods: {
    async stripeTokenHandler() {
      let displayError = document.getElementById('card-errors')
      if (!this.cardHolderName) {
        displayError.textContent = `Card name can't be blank`
        return
      } else {
        displayError.textContent = ''
      }

      const { token, error } = await stripe.createToken(cardNumber, {
        name: this.cardHolderName,
        address_line1: this.addressOne,
        address_line2: this.addressTwo,
        address_city: this.city,
        address_state: this.state,
        address_zip: this.zipcode
      })
      if (error) {
        // for cVV Expiration

        displayError.textContent = error
        return
      } else {
        displayError.textContent = ''
        // console.log(token)
        this.$store.dispatch('billing/addPaymentMethod', {
          paymentType: paymentMethodType.CREDITCARD,
          invoiceInfo: null,
          stripeToken: token.id
        })
      }
    }
  },
  computed: mapState({
    submittingPaymentMethod: state => state.billing.submittingPaymentMethod
  })
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.arrow-link {
  margin-top: 4rem;
}

.button-gemnote {
  margin-top: 1.25rem;
  font-size: 0.813rem;
  height: 2.5rem;
  padding: 0 1rem;
}

#card-expiry {
  border-right: 1px solid $onyx;
  border-bottom: none;
}

#card-cvc {
  border-bottom: none;
}

// stripe
.StripeElement {
  box-sizing: border-box;
  width: 100%;
  /* height: 40px; */
  border: 0px;
  border-bottom: 1px solid $onyx;
  border-radius: 0px;
  background-color: inherit;
  box-shadow: none;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
  outline: none;
  font-size: 16px;
  font-family: $inter;
  padding: 20px;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

form {
  width: 45%;
  margin: 1.5rem auto;

  .form-group {
    margin-bottom: unset !important;
  }

  .form-holder {
    border-left: 1px solid $onyx;
    border-right: 1px solid $onyx;
    border-top: 1px solid $onyx;
  }

  input {
    padding: 28px 20px !important;

    &::placeholder {
      color: #9b9b9b;
      font-size: 0.813rem;
      text-transform: uppercase;
    }
  }
}

.inline-inputs {
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $onyx;

  label {
    color: $onyx;
    display: flex;
    font-weight: normal;
    font-size: 0.813rem;

    padding: 0 20px;
    text-transform: uppercase;

    span {
      margin-left: 3px;
    }
  }
}

.card-errors {
  padding-top: 1rem;
  text-align: left;
  color: red;
  font-size: 14px;
}

@media (max-width: 900px) {
  form {
    width: 100%;
  }
}

.item {
  span {
    font-size: 10px;
    color: #514d43;
    font-weight: 500;
  }
}
</style>
